import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/requestor_icon.svg'
import _imports_1 from '@/assets/img/plus_icon.svg'
import _imports_2 from '@/assets/img/minus_icon.svg'
import _imports_3 from '@/assets/img/priority_normale.svg'
import _imports_4 from '@/assets/img/priority_urgente.svg'
import _imports_5 from '@/assets/img/priority_programmata.svg'
import _imports_6 from '@/assets/img/priority_null.svg'
import _imports_7 from '@/assets/img/clock_icon.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "fs_12 fw_500"
}
const _hoisted_3 = { class: "d-flex align-items-center fs_12 fw_500 mt-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "me-1"
}, null, -1)
const _hoisted_5 = { class: "interventoContainer" }
const _hoisted_6 = { class: "d-flex align-items-start" }
const _hoisted_7 = {
  key: 0,
  src: _imports_3
}
const _hoisted_8 = {
  key: 1,
  src: _imports_4
}
const _hoisted_9 = {
  key: 2,
  src: _imports_5
}
const _hoisted_10 = {
  key: 3,
  src: _imports_6
}
const _hoisted_11 = { class: "ms-1" }
const _hoisted_12 = { class: "d-block fw_700" }
const _hoisted_13 = { class: "d-block fw_500 mt-1" }
const _hoisted_14 = { class: "d-block fw_500 mt-2" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "marine d-block fw_700 mt-1" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = {
  key: 0,
  class: "grey d-block mt-1"
}
const _hoisted_20 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "fw_700 marine ms-1"
}
const _hoisted_24 = {
  key: 1,
  class: "fw_700 marine ms-1"
}
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "fw_700 marine ms-1"
}
const _hoisted_28 = {
  key: 1,
  class: "fw_700 marine ms-1"
}
const _hoisted_29 = {
  key: 0,
  class: "fs_12 fw_500 marine d-block"
}
const _hoisted_30 = {
  key: 1,
  class: "fw_700 marine ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_technicians_images = _resolveComponent("technicians-images")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ticketCard", {'selected' : _ctx.ticketSelected}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (!_ctx.hideDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$filters.date(_ctx.ticket.timeAssigned)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.ticket.requestor), 1)
        ])
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_1,
        class: "pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detailsOpened = !_ctx.detailsOpened))
      }, null, 512), [
        [_vShow, !_ctx.detailsOpened]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_2,
        class: "pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailsOpened = !_ctx.detailsOpened))
      }, null, 512), [
        [_vShow, _ctx.detailsOpened]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.ticket.priority == 'Normale')
          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
          : (_ctx.ticket.priority == 'Emergenza' || _ctx.ticket.priority == 'Urgente')
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : (_ctx.ticket.priority == 'Attività Programmate')
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : (_openBlock(), _createElementBlock("img", _hoisted_10)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, "Ticket: " + _toDisplayString(_ctx.ticket.wrId), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.ticket.probType), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.ticket.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_localized_text, {
          class: "fw_500",
          localizedKey: "Status:",
          text: "Status:"
        }),
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.ticket.status), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tecniciContainer", {'mb-0': !_ctx.detailsOpened}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticket.technicalVmList, (tech, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["placeFilter", {'active' : _ctx.selectedTechnicianId == tech.uId}]),
          key: index,
          onClick: ($event: any) => (_ctx.selectTechnician(tech))
        }, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createBlock(_component_technicians_images, {
              key: _ctx.ticket.wrId,
              role: tech.role,
              isActive: _ctx.selectedTechnicianId == tech.uId
            }, null, 8, ["role", "isActive"])),
            _createVNode(_component_localized_text, {
              localizedKey: tech.role.toLowerCase(),
              text: tech.role.toLowerCase(),
              class: "text-capitalize ms-1"
            }, null, 8, ["localizedKey", "text"])
          ]),
          (_ctx.detailsOpened)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(tech.name) + " " + _toDisplayString(tech.surname), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_17))
      }), 128))
    ], 2),
    (_ctx.detailsOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              class: "fw_500 fs_12 d-block mb-2",
              localizedKey: "Ore stimate",
              text: "Ore stimate"
            }),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              (_ctx.ticket.estLaborHours)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.ticket.estLaborHours), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "--"))
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              class: "fw_500 fs_12 d-block mb-2",
              localizedKey: "Ore effettive",
              text: "Ore effettive"
            }),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              (_ctx.ticket.hours_est)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.ticket.hours_est), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, "--"))
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              class: "fw_500 fs_12 d-block mb-2",
              localizedKey: "Apparecchiatura",
              text: "Apparecchiatura"
            }),
            (_ctx.ticket.eqStd)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.ticket.eqStd), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_30, "--"))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}